import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Spinner from '../../components/generics/Spinner';
import DetailHeader from '../../components/generics/DetailHeader';
import SelectableInventoryTable from '../../components/generics/SelectableInventoryTable';

import { fetchCreditNote, fetchCreditNoteSuccess, fetchCreditNoteFailure } from "../../store/creditNotes/actions";
import { withRouter } from "utils/WithRouter";

export class CreditNoteDetailContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  componentDidMount(){
    this.props.fetchCreditNote(this.props.match.params.id);
  }

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
      if (!this.props.creditNoteDetail.creditNote){
        return (<Spinner />);
      } else {
          return (
            <div className="animated fadeIn credit-note">
              <DetailHeader title="Issue Credit Note"
                            hideAction={true}
                            col1Title="Credit Note Number"
                            col1Desc={this.props.creditNoteDetail.creditNote.credit_note_number || '-'}
                            col1Link={`/credit_note/${this.props.creditNoteDetail.creditNote.id}`}
                            col2Title="Invoice Number"
                            col2Desc={this.props.creditNoteDetail.creditNote.invoice_data.invoice_number}
                            col2Link={`/invoice/${this.props.creditNoteDetail.creditNote.invoice}`}
                            col3Title="Credit Note Date"
                            col3Desc={moment(this.props.creditNoteDetail.creditNote.created_at).format('LLL')}
                            col4Title="Invoice Date"
                            col4Desc={moment(this.props.creditNoteDetail.creditNote.invoice_data.invoice_date).format('LLL')}/>
            <SelectableInventoryTable list={this.props.creditNoteDetail.creditNote.data}
                                      tableTitle="Inventory items in credit Note"
                                      readOnly={true}/>
            </div>
        );
      }
    }
  }

const mapStateToProps = (state, ownProps) => {
  return {
    creditNoteDetail: state.creditNotes.creditNoteDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCreditNote: (id) => {
      dispatch(fetchCreditNote(id)).payload.then((response) => {
        dispatch(fetchCreditNoteSuccess(response.data));
      }, (error) => {
        dispatch(fetchCreditNoteFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreditNoteDetailContainer));
